import unionBy from 'lodash/unionBy';
import { getAll } from '@/api/ligneCommande/index';
import * as allTypes from '@/store/mutation-type';
import genererCritereRechercheLigneCommande
  from '@/services/ligneCommande/genererCritereRechercheLigneCommande';
import genererCritereRechercheLigneCommandeAchat
  from '@/services/achat/lignesCommandeAchat/genererCritereRechercheLigneCmde';
import genererCritereRecherchePrevisionnel
  from '@/services/ligneCommande/genererCritereRecherchePrevisionnel';
import genererCritereRecherchePrevisionnelCBA
  from '@/services/ligneCommande/genererCritereRecherchePrevisionnelCBA';
import transformer from '@/services/ligneCommande/ligneCommandeServerTableDataTransformer';
import { getPiecesJointeInstructionPoseByIds } from '@/services/piecesJointes/getPiecesJointe';
import * as types from './ligneCommande-mutation-type';

export function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRechercheVentes: genererCritereRechercheLigneCommande(),
    criteresRechercheAchats: genererCritereRechercheLigneCommandeAchat(),
    lastPayload: {},
    criteresRecherchePrevisionnel: genererCritereRecherchePrevisionnel(),
    criteresRecherchePrevisionnelCBA: genererCritereRecherchePrevisionnelCBA(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_CRITERE_VENTES](state, critere) {
    state.criteresRechercheVentes = critere;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_CRITERE_PREVISIONNEL](state, critere) {
    state.criteresRecherchePrevisionnel = critere;
  },
  [types.SET_CRITERE_PREVISIONNEL_CBA](state, critere) {
    state.criteresRecherchePrevisionnelCBA = critere;
  },
  [types.SET_CRITERE_ACHATS](state, critere) {
    state.criteresRechercheAchats = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadLigneCommande({ commit }, search) {
    const response = (await getAll(search)).data.result;
    if (search.withInstructionPosePj) {
      const devisCommandes = unionBy(response.items.map(i => i.devisCommande), 'id');
      await getPiecesJointeInstructionPoseByIds(devisCommandes);
      response.items.forEach(el => {
        const dcf = devisCommandes.find(i => i.id === el.devisCommande.id);
        el.devisCommande.instructionPosePj = dcf.cheminMin;
      });
    }
    commit(types.SET_LAST_PAYLOAD, transformer(search));
    commit(types.SET_ITEMS, response.items);
    commit(types.SET_TOTAL, response.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRechercheVentes: state => {
    return state.criteresRechercheVentes;
  },
  criteresRecherchePrevisionnel: state => {
    return state.criteresRecherchePrevisionnel;
  },
  criteresRecherchePrevisionnelCBA: state => {
    return state.criteresRecherchePrevisionnelCBA;
  },
  criteresRechercheAchats: state => {
    return state.criteresRechercheAchats;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
